export type WfhConfiguration = { wfhPolicyId:number; policyCode:string; policyName:string; description:string|null; effectiveFrom:string; maximumDaysPerMonth:number; maximumDaysPerYear:number; maximumConsecutiveDays:number; minimumNoticeDays:number; allowHalfDay:boolean; isDefault:boolean; isActive:boolean; rowVersion:number };
export const PERMISSION_ORG_POLICY_NOTES_MAX_LENGTH = 4000;
export type PermissionOrgPolicy = {
  permissionConfigurationId: number | null;
  organizationId: number | null;
  maximumPermissionsPerMonth: number;
  minimumDurationMinutes: number;
  maximumDurationMinutes: number;
  notes: string;
  rowVersion: number;
};
export type PermissionOrgPolicyInput = {
  maximumPermissionsPerMonth: number;
  minimumDurationMinutes: number;
  maximumDurationMinutes: number;
  notes: string;
  rowVersion: number;
};
export type PermissionConfiguration = { permissionTypeId:number; permissionTypeCode:string; permissionTypeName:string; description:string|null; minimumDurationMinutes:number; maximumDurationMinutes:number; permissionPolicyId:number; policyCode:string; policyName:string; effectiveFrom:string; maximumPermissionsPerDay:number; maximumPermissionsPerMonth:number; maximumPermissionsPerYear:number; isDefault:boolean; isActive:boolean; rowVersion:number };
export type CreateWfhConfigurationInput = Omit<WfhConfiguration,'wfhPolicyId'|'isActive'|'rowVersion'>;
export type CreatePermissionConfigurationInput = {
  permissionTypeCode: string;
  permissionTypeName: string;
  description: string | null;
};
export type UpdateWfhConfigurationInput = CreateWfhConfigurationInput & { isActive: boolean; rowVersion: number };
export type UpdatePermissionConfigurationInput = CreatePermissionConfigurationInput & { isActive: boolean; rowVersion: number };
